<template>
  <div>
    <v-data-table
      class="astra-table"
      dense
      height="74vh"
      fixed-header
      :headers="controller.headers"
      :options.sync="controller.options"
      :server-items-length="controller.truckDriverPagination.total"
      :items="controller.truckDriverPagination.items"
      :loading="controller.loading"
      :footer-props="{
        'items-per-page-options': [40, 80],
      }"
    >

      <template v-slot:[`item.birthDate`]="{ item }">
          {{ controller.formatDate(item.birthDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-btn
            icon
            @click="controller.changeEquipment(item)"
            class="px-2"
          >
            <v-icon
              color="#FBC02D"
              small
            >mdi-account-key</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="controller.change(item)"
            class="px-2"
            v-if="hadPermission(1,2)"
          >
            <v-icon
              color="editBtn"
              small
            >mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="controller.delete(item)"
            class="px-2"
            v-if="hadPermission(1,3)"
          >
            <v-icon
              color="deleteBtn"
              small
            >mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:top>
        <v-row
          class="pa-3"
          no-gutters
        >
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'py-3 d-flex align-center justify-center'
                : 'd-flex align-center'
            "
            cols="12"
            sm="12"
            md="8"
            lg="8"
            xl="8"
          >
            <span class="table-title">Motoristas</span>
          </v-col>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'd-flex flex-column align-center justify-center'
                : 'd-flex align-center justify-end'
            "
            cols="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <v-text-field
              class="pa-2 search-tf"
              style="width: 250px"
              outlined
              color="primary"
              hide-details
              dense
              placeholder="Pesquisar nome/telefone..."
              v-model="controller.search"
            ></v-text-field>
            <v-dialog
              max-width="600"
              persistent
              scrollable
              v-model="controller.dialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="hadPermission(1,1)"
                  class="action-btn d-flex justify-center"
                  height="40"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  tile
                  @click.stop="controller.open()"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Adicionar
                </v-btn>
              </template>
              <v-card class="crud-card">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <span class="table-title">Motorista</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pt-3 pb-1">
                  <v-form
                    ref="crud"
                    lazy-validation
                  >
                  <v-row>
                      <v-col>
                          <div class="form-input-group">
                            <v-text-field
                                class="search-tf"
                                single-line
                                id="name" 
                                :rules="[(v) => !!v || 'Campo obrigatório']"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                placeholder="Nome"
                                v-model="controller.form.name"
                            />
                            <label for="name">Nome</label>
                          </div>

                          <div class="form-input-group">
                            <v-text-field
                                class="search-tf"
                                single-line
                                id="email"
                                :rules="[
                                (v) => !!v || 'Campo obrigatório',
                                controller.emailRules
                                ]"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                placeholder="E-mail"
                                v-model="controller.form.email"
                            />
                            <label for="email">E-mail</label>
                          </div>

                          <div class="form-input-group">
                            <v-text-field
                                class="search-tf"
                                single-line
                                id="birthDate"
                                :rules="[
                                (v) => !!v || 'Campo obrigatório',
                                (v) => controller.validateDate(v) || 'Data inválida'
                                ]"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                placeholder="Data de Nascimento"
                                v-model="controller.form.birthDateFormatted"
                                v-mask="'##/##/####'"
                            />
                            <label for="birthDate">Data de Nascimento</label>
                          </div>

                          <div class="form-input-group">
                            <v-text-field
                                class="search-tf"
                                single-line
                                id="cpfcnpj"
                                :rules="[(v) => !!v || 'Campo obrigatório']"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                placeholder="CPF/CNPJ"
                                v-model="controller.form.cpfCnpj"
                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                            />
                            <label for="cpfcnpj">CPF/CNPJ</label>
                          </div>

                          <div class="form-input-group">
                            <v-text-field
                                class="search-tf" 
                                single-line
                                id="phone"
                                :rules="[
                                  (v) => !!v || 'Campo obrigatório',
                                  controller.phoneRules
                                ]"
                                outlined
                                required
                                dense
                                placeholder="Telefone"
                                v-model="controller.form.phone"
                                v-mask="'(##) #####-####'"
                            />
                            <label for="phone">Telefone</label>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  <v-divider></v-divider>
                </v-card-text>
                <v-card-actions class="px-6 pb-3">
                  <v-btn
                    class="action-btn d-flex justify-center"
                    height="36"
                    width="114"
                    color="primary"
                    tile
                    outlined
                    @click="controller.close()"
                  >
                    <v-icon left>mdi-close</v-icon>
                    Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="action-btn d-flex justify-center"
                    height="36"
                    width="114"
                    color="primary"
                    tile
                    @click="controller.create()"
                    :loading="controller.loading"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog
      persistent
      max-width="500"
      scrollable
      v-model="controller.equipmentsDialog"
    >
      <v-card class="crud-card">
       <v-card-title class="flex-column">
        <v-spacer></v-spacer>
        <span class="table-title">
          Equipamentos visíveis para o Motorista
        </span>
        <span class="driver-name mt-2">
          {{ controller.form.name }}
        </span>
        <v-spacer></v-spacer>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="pa-6 d-flex flex-column"
            >
              <div class="form-input-group">
                <v-autocomplete
                  class="search-tf"
                  single-line
                  id="equipment"
                  background-color="transparent"
                  outlined
                  required
                  dense
                  placeholder="Buscar equipamentos"
                  :search-input.sync="controller.searchEquipment"
                  :items="controller.equipmentPagination.items"
                  item-text="name"
                  item-value="id"
                >
                  <template #item="{ item }">
                    <v-list-item @click="controller.toggleItemEquipment(item)">
                      <div>
                        <v-simple-checkbox
                          v-ripple
                          color="accent"
                          :value="controller.isSelectedEquipment(item)"
                          @click="controller.toggleItemEquipment(item)"
                        />
                      </div>
                      <div class="ml-2 d-flex align-center">
                        <span class="pl-2">{{ item.name }}</span>
                      </div>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <label for="equipment">Buscar equipamentos</label>
              </div>
              <div
                class="d-flex flex-column align-center"
                style="min-height: 200px"
              >
                <h3>Equipamentos selecionados:</h3>
                <div
                  class="my-2 d-flex flex-wrap justify-center"
                  v-if="controller.equipmentSelected.length > 0"
                >
                  <div
                    v-for="(equip, i) in controller.equipmentSelected"
                    :key="i"
                    class="pl-4 d-flex align-center equip-chip"
                  >
                    <b>{{ equip.name }}</b>
                    <v-btn
                      @click="controller.removeItemEquipment(equip)"
                      icon
                    >
                      <v-icon
                        size="20"
                        color="#ff0000"
                      >mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <span>Nenhum equipamento selecionado</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 pb-3">
          <v-btn
            class="action-btn d-flex justify-center"
            height="36"
            width="114"
            color="primary"
            tile
            outlined
            @click="controller.closeEquipmentDialog()"
          >
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="action-btn d-flex justify-center"
            height="36"
            width="114"
            color="primary"
            tile
            @click="controller.saveEquipmentVisibility()"
            :loading="controller.loading"
          >
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { truckDriverController } from "@/di/di";
import { mask } from "vue-the-mask";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import _ from "lodash";

export default {
  name: "truckDriver-page",
  directives: { mask },
  data: (context) => ({
      controller: truckDriverController(context),
  }),
  watch: {
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search"() {
      this.controller.watchSearch();
    },
    "controller.searchEquipment": _.debounce(function () {
     this.controller.watchEquipmentSearch();
    }, 500),
    "controller.equipmentOptions"() {
      this.controller.watchEquipmentOptions();
    },
  },
};
</script> 

<style scoped lang="scss">
.astra-table {
border-radius: 20px;
background-color: var(--v-secondary-base) !important;
}

.toolbar-table {
border-top-left-radius: 20px !important;
border-top-right-radius: 20px !important;
}

::v-deep .v-data-table.v-data-table--fixed-header thead th {
background-color: var(--v-secondary-base) !important;
}

.action-btn {
text-transform: none;
border-radius: 10px !important;
}

.search-tf {
border-radius: 10px !important;
}

.table-title {
font-family: "Roboto";
font-style: normal;
font-weight: 300;
font-size: 20px;
line-height: 20px;
text-align: center;
}

.crud-card {
border-radius: 20px;
background-color: var(--v-secondary-base) !important;
}

::v-deep .v-dialog {
border-radius: 20px !important;
}

label {
order: -1;
}

.v-input:focus-within + label {
color: var(--v-primary-base) !important;
}

.form-input-group {
display: flex;
flex-direction: column;
}

::v-deep tbody {
  tr:hover {
    background-color: var(--v-tertiary-base) !important;
  }
}

.driver-name {
  font-size: 20px;
  font-weight: bold;
}

.equip-chip {
background-color: var(--v-tertiary-base);
border-radius: 8px;
margin: 2px;
}
</style>
